export function naturalSortStringComparator(valueA, valueB) {
  // strip non numeric characters and sort naturally
  const valueAInteger = valueA.replace(/\D/g, "");
  const valueBInteger = valueB.replace(/\D/g, "");
  return valueAInteger.localeCompare(valueBInteger, "en", { numeric: true });
}
